export enum LookupFormat {
    NoFormating,
    SquareBracket,
    CurlyBracket,
    Space,
    Dash,
    Pipe,
    DoublePipe,
    Slash,
    DoubleSlash,
}